<template>
  <section id="historySection" class="mt-5 scroll-snap-section">
    <h2>Historical DNA</h2>
    <div v-if="sharingStore.vikingResult || sharingStore.archaicResult">
      <p>Explore your ancestry with our advanced test, uncovering connections to Viking and Archaic roots.
        Discover
        the stories embedded in your genes as you browse shared results, offering a glimpse into the rich
        tapestry
        of human history. Gain insights into your unique identity and the fascinating journey that has shaped
        it.
      </p>

      <div class="mt-5">
        <div class="image-bg">
          <h3><span class="bg-white image-title">Viking</span></h3>
          <img class="img-fluid" :src="viking" alt="Viking" />
        </div>
        <div class="mt-4">
          <p class="mb-0 t-14">Closest group</p>
          <h4>{{ populationName }}</h4>
        </div>
        <div class="mt-4">
          <div class="d-flex gap-2 align-items-center">
            <p class="m-0">
              <span class="d-block t-14">Percentile</span>
              <strong class="d-block">{{ sharingStore.vikingResult.percentile }}</strong>
            </p>
            <BarChart class="flex-shrink-0" :percentile="sharingStore.vikingResult.percentile" />
          </div>
        </div>
      </div>

      <div class="mt-5">
        <div class="image-bg">
          <h3><span class="bg-white image-title">Archaic</span></h3>
          <img :src="archaic" alt="Archaic" class="img-archaic img-fluid" />
        </div>
        <div class="mt-4">
          <p class="mb-0 t-14">Closest Neanderthal Remnant</p>
          <h4>
            {{
              JSON.parse(sharingStore.archaicResult.results).neanderthal
                .closest_sample.name
            }}
          </h4>
        </div>
        <div class="mt-4">
          <div class="d-flex gap-2 align-items-center">
            <p>
              <span class="d-block t-14">Neanderthal</span>
              <span class="d-block t-14">Percentile</span>
              <strong>{{
                JSON.parse(sharingStore.archaicResult.results).neanderthal
                  .percentiles["Living DNA customers"]
              }}</strong>
            </p>
            <BarChart class="flex-shrink-0" :percentile="JSON.parse(sharingStore.archaicResult.results).neanderthal.percentiles[
              'Living DNA customers'
            ]
              " />
          </div>
          <div class="d-flex gap-2 align-items-center mt-4">
            <p>
              <span class="d-block t-14">Denisovan</span>
              <span class="d-block t-14">Percentile</span>
              <strong>{{
                JSON.parse(sharingStore.archaicResult.results).denisova.percentiles[
                "Living DNA customers"
                ]
              }}</strong>
            </p>
            <BarChart class="flex-shrink-0" :percentile="JSON.parse(sharingStore.archaicResult.results).denisova.percentiles[
              'Living DNA customers'
            ]
              " />
          </div>
        </div>
      </div>

    </div>
    <div v-else class="card card-maternal mt-5">
      <div class="card-body">
        <p class="card-text">{{ sharingStore.name }} does not have historical results to share</p>
      </div>
    </div>

  </section>
</template>
<script setup>
import viking from '@/assets/images/share/viking.jpg';
import archaic from '@/assets/images/share/archaic.jpg';
import { useSharingStore } from "@/store/sharing";
import BarChart from "@/components/charts/BarChart.vue";

const sharingStore = useSharingStore();

const populationName = {
  swedishdanish_vikings: "Vikings of Denmark & Sweden",
  eastern_vikings: "Vikings of Eastern Europe",
  norwegian_vikings: "Vikings of Norway",
}[sharingStore?.vikingResult?.closestPop];

</script>
<style lang="scss">
.h-12 {
  height: 4rem;
}

.image-bg {
  overflow: hidden;
  position: relative;

  h3 {
    padding: 24px;
  }

  img {
    opacity: 0.2;
    position: absolute;
    inset: 0;
    width: 100%;
    left: 0;
    top: 0;
  }

  .img-archaic {
    top: -38px
  }

  .image-title {
    position: relative;
    z-index: 2;
  }
}

.percentile-img {
  width: 200px;

  @media(min-width:768px) {
    width: auto;
  }
}
</style>